import { useTranslation } from 'react-i18next';

import { usePaymentMutation } from '@/api/queries/payment';

import { ToastNotification } from '../components/ToastNotification/ToastNotification';
import { Playdeck } from '../lib/playdeck';
import { type BuyCoinItemProps } from '../types/components';
import { type ActivateVipStatusResponseType } from '../types/query/user';

import { useTonAutoConnect } from './ton-auto-connect';

import coinPng from '/img/tgem.png';
import coinWebp from '/img/tgem.webp';

type PropReturn = (
  currency: 'XTR' | 'TON',
  activeOffer: BuyCoinItemProps,
) => Promise<void>;

const useBuyCoinRequest = (): PropReturn => {
  const { t } = useTranslation();
  const [buyCoins] = usePaymentMutation();
  const connectWalletAndDoTransaction = useTonAutoConnect();

  const onBuyCoins = async (
    currency: 'XTR' | 'TON',
    activeOffer: BuyCoinItemProps,
  ): Promise<void> => {
    if (!activeOffer) {
      return;
    }

    // for ActivateVipStatusResponseType response type

    if (currency === 'TON') {
      await new Promise<void>((resolve, reject) => {
        connectWalletAndDoTransaction(
          async () =>
            (await buyCoins({
              amount: activeOffer.coin,
              currency,
              type: 'tgem',
            }).unwrap()) as ActivateVipStatusResponseType,
          {
            onSuccess: () => {
              ToastNotification(t('Pending Transaction'), {
                img: coinPng,
                webp: coinWebp,
              });
              resolve();
            },
            onError: () => {
              ToastNotification(t('Something went wrong, please try again'), {
                img: coinPng,
                webp: coinWebp,
              });
              reject(new Error('Transaction failed'));
            },
          },
        );
      });
    } else {
      const response = await buyCoins({
        amount: activeOffer.coin,
        currency,
        type: 'tgem',
      }).unwrap();

      // for ActivateVipStatusBuyLinkResponseType response type
      if ('link' in response) {
        await new Promise<void>((resolve, reject) => {
          Playdeck.requestPayment({
            amount: activeOffer.starPrice,
            description: 'buy tgem',
            externalId: `buy-tgem-${activeOffer.starPrice}`,
          });
          Telegram.WebApp.openInvoice(response.link, (status) => {
            if (status === 'cancelled' || status === 'failed') {
              ToastNotification(t('Something went wrong, please try again'), {
                img: coinPng,
                webp: coinWebp,
              });
              reject(new Error(`Payment ${status}`));
            } else {
              resolve();
            }
            console.log(`payment status ${status}`);
          });
        });
      }
    }
  };

  return onBuyCoins;
};

export { useBuyCoinRequest };
